import React from 'react';
import { MERGE_PRODUCT_DURATION, PACKAGE_LEVEL } from '@src/constants/package';
import CheckOrCross from '../Shared/CheckOrCross';

const monetizeCommunityVoicesFeatures = ({ packages, activeGranularity }) => {
  const isMonthly = activeGranularity === MERGE_PRODUCT_DURATION.MONTHLY;

  const isCheck = (pkg) => {
    if (isMonthly) {
      return false;
    }

    return [
      PACKAGE_LEVEL.SPECIAL,
      PACKAGE_LEVEL.VIP,
      PACKAGE_LEVEL.CUSTOM,
    ].includes(pkg.level);
  };

  return packages.map((pkg) => (
    <CheckOrCross key={pkg.code} isCheck={isCheck(pkg)} />
  ));
};

export default monetizeCommunityVoicesFeatures;
